import { color } from "../resource";

export const QUOTA_TYPE = [
  { key: 1, value: "QUOTA_INDIVIDUAL", label: "โควตารายร้าน กำหนดแบบรายสินค้า" },
  { key: 2, value: "QUOTA_GROUP", label: "โควตารายร้าน กำหนดแบบกลุ่มสินค้า" },
  { key: 3, value: "QUOTA_TOTAL", label: "โควตารวม" },
];
export const MAP_QUOTA_TYPE: any = {
  QUOTA_INDIVIDUAL: "โควตารายร้าน แบบรายสินค้า",
  QUOTA_GROUP: "โควตารายร้าน แบบกลุ่มสินค้า",
  QUOTA_TOTAL: "โควตารวม",
};
export const QUOTA_TYPE_DETAIL: any = {
  QUOTA_INDIVIDUAL: "โควตารายร้าน |  กำหนดแบบรายสินค้า",
  QUOTA_GROUP: "โควตารายร้าน |  กำหนดแบบกลุ่มสินค้า",
  QUOTA_TOTAL: "โควตารวม",
};

export const QUOTA_SHOP_PRICE_CONDITION: any = {
  DENY_ORDER: "เมื่อใช้โควตาครบ ไม่สามารถสั่งซื้อสินค้าเดิมต่อได้",
  CONTINUE_NORMAL_PRICE: "เมื่อใช้โควตาครบ สามารถสั่งซื้อสินค้าเดิมต่อได้ในราคาปกติ",
};
export const NON_QUOTA_SHOP_PRICE_CONDITION: any = {
  DENY_ORDER: "ไม่สามารถสั่งซื้อได้ทุกสินค้า",
  CONTINUE_NORMAL_PRICE: "สามารถสั่งซื้อสินค้าเดียวกับร้านที่เข้าร่วมได้ในราคาปกติได้",
};

export const STATUS_WORD_COLOR: any = {
  false: color["grayishBlue"],
  true: color["success"],
};
export const STATUS_WORD: any = {
  false: "ปิดใช้งาน",
  true: "เปิดใช้งาน",
};
